import { ALTERAR_REGISTROS_POR_PAGINA_CTE_OS } from '../../actions/types'

const initialState = 10

export default function reducerRegistrosPorPaginalCteOs(state = initialState, action) {
  switch (action.type) {
    case ALTERAR_REGISTROS_POR_PAGINA_CTE_OS: {
      return action.payload
    }

    default:
      return state
  }
}
